import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { Review, ReviewsState } from "../../types/types";

import type { RootState } from "../index";

export const fetchReviewsByCategory = createAsyncThunk<
    Review[],
    number | null,
    { state: RootState; rejectValue: string }
>(
  "reviews/fetchReviewsByCategory",
  async (categoryId, { rejectWithValue }) => {
    const API_URL = process.env.REACT_APP_URL_BACKEND;

    try {
      const baseUrl = `${API_URL}/api/v1/reviews/`;
      const url = (() => {
        if (categoryId === null) return baseUrl;
        const params = new URLSearchParams({
          "product__product_category__id": String(categoryId),
        });

        return `${baseUrl}?${params.toString()}`;

      })();

      const response = await fetch(url);

      if (!response.ok) {
        return rejectWithValue("Ошибка при загрузке отзывов");
      }

      return await response.json();
    } catch {
      return rejectWithValue("Ошибка сети или сервера");
    }
  },
  {
    condition: (_, { getState }) => {
      const { reviewsByCategory } = getState();

      return !reviewsByCategory.loading;
    },
  }
);

const initialState: ReviewsState = {
  reviews: [],
  loading: false,
  error: null,
};

const reviewsByCategorySlice = createSlice({
  name: "reviewsByCategory",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchReviewsByCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchReviewsByCategory.fulfilled, (state, action: PayloadAction<Review[]>) => {
        state.loading = false;
        state.reviews = action.payload;
      })
      .addCase(fetchReviewsByCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Что-то пошло не так";
      });
  },
});

export const selectReviewsByCategory = (state: RootState) =>
  state.reviewsByCategory.reviews;

export const selectLoading = (state: RootState) =>
  state.reviewsByCategory.loading;

export const selectError = (state: RootState) =>
  state.reviewsByCategory.error;

export default reviewsByCategorySlice.reducer;
